export enum AllPaginationDefaults {
    Page = 1,
    PageSize = 500,
    Order = 'desc',
    OrderBy = 'creationTime',
}